import React from 'react';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer.js';
import Explore from '../../Components/Explore/Explore';

const ExploreAll = () => {
    return (
        <>
            <Header/>
            <Explore/>
            <Footer/>
        </>
    );
};

export default ExploreAll;